import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/applicationManage',
  name: 'applicationManage',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/appConfig',
      component: () => import('@/views/operation/applicationManage/index.vue'),
      meta: {
        title: '应用设置',
        icon: 'application'
      }
    }
  ]
}
